const BACK =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080'
    : '';

export { BACK };